
import React from 'react';
import stillpic from './assets/Still_logo_2.png';

const IntroSection = () => {
  return (
    <section className="intro">
      <div className="intro-content">
        <div className="intro-image">
          <img src={stillpic} alt="brand logo" />
        </div>
        <div className="intro-description" id= "shop">
          <h1>MOVE AT YOUR OWN PACE. NOT THEIRS</h1>
          <p>Crafted with intentionality.</p>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
